var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.PDN.isVisible
    ? _c(
        "lbs-dialog",
        {
          staticClass: "lbs-scope-container",
          attrs: { title: _vm.$t("tools-caption") },
          on: { close: _vm.PDN_TOGGLE_NAVIGATOR }
        },
        [
          _c(
            "div",
            {
              staticClass: "lbs-scope-container pdn-ui",
              attrs: { slot: "body" },
              slot: "body"
            },
            [
              !_vm.PDN.isLoaded
                ? _c(
                    "div",
                    [
                      _c("p", [
                        _vm._v(
                          "\n        " + _vm._s(_vm.$t("loading")) + "\n      "
                        )
                      ]),
                      _vm._v(" "),
                      _c("b-progress", {
                        staticClass: "mb-3",
                        attrs: { value: 100, variant: "info", animated: "" }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.PDN.isLoaded && !_vm.PDN.error && _vm.PDN.pins.length === 0
                ? _c("b-alert", { attrs: { variant: "info", show: "" } }, [
                    _vm._v("\n      " + _vm._s(_vm.$t("no-pins")) + "\n    ")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.PDN.error
                ? _c("b-alert", { attrs: { variant: "danger", show: "" } }, [
                    _vm._v("\n      " + _vm._s(_vm.PDN.error) + "\n    ")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.PDN.isLoaded && !_vm.PDN.error && _vm.PDN.pins.length > 0
                ? _c("b-pagination", {
                    attrs: {
                      size: "md",
                      align: "center",
                      "total-rows": _vm.PDN.pins.length,
                      limit: 6,
                      "per-page": 1
                    },
                    on: { change: _vm.change },
                    model: {
                      value: _vm.PDN.selectedIndex,
                      callback: function($$v) {
                        _vm.$set(_vm.PDN, "selectedIndex", $$v)
                      },
                      expression: "PDN.selectedIndex"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "lbs-scope-container",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _vm.PDN.error
                ? _c(
                    "b-button",
                    { attrs: { size: "sm" }, on: { click: _vm.PDN_LOAD_PINS } },
                    [_vm._v("\n      Reload\n    ")]
                  )
                : _vm._e()
            ],
            1
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/vil/uScope-extensions/PinDropNavigator/PinDropNavigator.vue?vue&type=template&id=1bd9c67a&scoped=true&
// module id = 342
// module chunks = 0